export default __webpack_public_path__ + "static/media/insuofice.4ff83ddb.png";